"use client";

import { useEffect } from "react";

interface GlobalErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error("Global error:", error);
	}, [error]);

	return (
		<html lang="en">
			<body className="min-h-screen bg-zinc-50 font-sans dark:bg-background flex items-center justify-center">
				<div className="max-w-md w-full space-y-8">
					<div className="text-center">
						<h2 className="text-page-title font-normal tracking-[-0.025em] text-gray-900 dark:text-white">
							Something went wrong!
						</h2>
						<p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
							{error.message}
						</p>
						<div className="mt-6">
							<button
								type="button"
								onClick={reset}
								className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
							>
								Try again
							</button>
						</div>
					</div>
				</div>
			</body>
		</html>
	);
}
